import React from 'react'
import { useMsal } from '@azure/msal-react'
import { loginRequest } from '../../../msalConfig'
import './style.scss'
import { SplashLoadingForm } from '../../forms/SplashLoadingForm'
import { useTranslation } from 'react-i18next'

export const SignedOut = () => {
  // This component is displayed when the user is not logged-in.
  // We call the MSAL loginRedirect to force the user to sign-in.
  const { instance } = useMsal()
  const { t } = useTranslation()
  instance.loginRedirect(loginRequest)

  return (
    // TODO Display a waiting screen while the microsoft login is redirecting to Azure...
    <SplashLoadingForm topMessage={t('common.loading.logout')} />
  )
}
